<template>
  <div>
    <div class="common-select">
      <template v-for="(item,index) in filterCondition" v-if="filterCondition" >
          <filter-grid
            :index="index" 
            :filterName="item.name" 
            :type="item.type" 
            :childItem="item.children" 
            :curFilter="curFilter[index]"
            @chooseItem="selelctChoose"
            @deleteItem="deleteItem"
          />
          
      </template>      
    </div>

    <div class="common-result" v-if="curFilter.length>0 || yearSelect">
      <select-pop-btn  v-if="yearSelect" :selectCondition="selectCondition" @clickItem="selectConditonChoose" />

      <template v-for="(item,index) in curFilter">
        <template v-for="(subItem,subIndex) in item.items">
          <p ><span>{{item.filterName}}:{{subItem.name}}</span><em class="iconfont icon-close-fill"  @click="delectLabel(subItem,index)"></em></p>

        </template>
      </template>
    </div>
  </div>
   
</template>
<script>
import SelectPopBtn from '../common/selectPopBtn.vue'
import FilterItem from './filterItem.vue'
import filterGrid from './filterGrid.vue'
export default {
  name: 'commonFilterMult', //多选及反选
  props: {
    filterCondition:Array,
    yearSelect: Boolean,
    selectCondition:Object,
    isMult:Boolean,
  },
  components:{
    FilterItem,
    SelectPopBtn,
    filterGrid
  },
  data(){
    return{
      
      curFilter:[],
    }
  },
  methods:{
    

    // 组件选中标签
    selelctChoose(info){
      // 判断是否已选
      let curFilter = this.curFilter;
      let curs=[]; 
      if(curFilter[info.index] ){
        curs = curFilter[info.index].items;
        curs.push(info.items[0]);
        this.$set(this.curFilter[info.index],"items",curs)
      }else{
        curs=info;
        this.$set(this.curFilter,info.index,curs)
      }
      this.$emit("filterList",{
        filter:this.curFilter
      })
    },

    //组件反选删除
    deleteItem(info){
      let curFilter =  this.curFilter;
      let deleteIndex=-1;
      curFilter.forEach(item=>{
        curFilter[info.index].items.forEach((subItem,subIndex)=>{
          if(subItem.name == info.items[0].name){
            deleteIndex = subIndex
          }
        })
      })
      this.$delete(this.curFilter[info.index].items,deleteIndex)
      this.$emit("filterList",{
        filter:this.curFilter
      })
      
    },

    //删除标签
    delectLabel(info,index){
      // this.curFilter.splice(index,1);
      this.$set(this.curFilter,index,{})
      this.$emit("filterList",{
        filter:this.curFilter
      })
    },
    // 年份选择
    selectConditonChoose(info){
      this.$emit("selectConditonChoose",info)
    }
  }
}
</script>
<style scoped >


</style>